import { createNlsMiddleware, userstate } from 'lcc-state';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, WNodeFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';
import { create, w } from '@dojo/framework/core/vdom';
import { convertToBoolean } from '@holmescorp/common';
import { ResourceParser } from '@holmescorp/resource-parser';

import { WelcomeView } from './welcome-view';

export interface LandingPageProperties {}

interface LandingPageIcache {
	use_welcome_view: boolean;
}

const settings = createNlsMiddleware('settings');
const icache = createICacheMiddleware<LandingPageIcache>();
const factory = create({
	settings,
	icache,
	userstate
}).properties<LandingPageProperties>();

export const LandingPage = factory(({ middleware: { settings, icache, userstate } }) => {
	const { get: uget, path: upath } = userstate;

	const {
		messages: {
			require_video_overview = '[settings] require_video_overview',
			landing_page_resources = '[settings] landing_page_resources'
		}
	} = settings();

	const { watched_video } = uget(upath('toolstate', 'landing'));
	const requireVideo = convertToBoolean(require_video_overview);

	const use_welcome_view = icache.getOrSet('use_welcome_view', !watched_video && requireVideo);

	const welcomePage = w(WelcomeView, {});

	if (use_welcome_view) {
		return welcomePage;
	} else {
		return w(ResourceParser, { topicid: 'landing_page_resources', messages: { default: landing_page_resources } });
	}
});
